// extracted by mini-css-extract-plugin
module.exports = {"main-component":"teamMotivationSurvey_main-component__3CNsO"};